import Step1 from "@/modules/onboarding-form/components/onboarding-wizard/step-1";
import Step2 from "@/modules/onboarding-form/components/onboarding-wizard/step-2";
import Step3 from "@/modules/onboarding-form/components/onboarding-wizard/step-3";
// import Step4 from "@/modules/onboarding-form/components/onboarding-wizard/step-4";
import Step5 from "@/modules/onboarding-form/components/onboarding-wizard/step-5";
import Step6 from "@/modules/onboarding-form/components/onboarding-wizard/step-6";
import Step7 from "@/modules/onboarding-form/components/onboarding-wizard/step-7";
import Step8 from "@/modules/onboarding-form/components/onboarding-wizard/step-8";
import Step9 from "@/modules/onboarding-form/components/onboarding-wizard/step-9";
import RecommendedApps from "@/modules/onboarding-form/components/onboarding-wizard/recommended-apps/recommended-apps";
import AppsSetup from '@/modules/onboarding-form/components/onboarding-wizard/recommended-apps/apps-setup'
import Layout from "@/modules/onboarding-form/components/onboarding-wizard/Layout";
// import StepFinal from "@/modules/onboarding-form/components/onboarding-wizard/step-final";
import StepPublished from "@/modules/onboarding-form/components/onboarding-wizard/step-published";

import BakeryStoreLayout from "@/assets/layouts/BakeryStore.svg?react";
import BeautyShopLayout from "@/assets/layouts/BeautyShop.svg?react";
import CareerServiceLayout from "@/assets/layouts/CareerService.svg?react";
import CleaningServiceLayout from "@/assets/layouts/CleaningService.svg?react";
import FashionRetailerLayout from "@/assets/layouts/FashionRetailer.svg?react";
import HandymanLayout from "@/assets/layouts/Handyman.svg?react";
import ParentingBlogLayout from "@/assets/layouts/ParentingBlog.svg?react";
import SandwichShopLayout from "@/assets/layouts/SandwhichShop.svg?react";
import SpaLayout from "@/assets/layouts/Spa.svg?react";

export const TEMPLATE_STYLES = {
  PLAYFUL: "playful",
  MODERN: "modern",
  PROFESSIONAL: "professional",
  BOLD: "bold",
  CLASSIC: "classic",
};

export const LAYOUT_TEMPLATES = [
  {
    id: "9937a286-32ea-4e6e-88f4-7446c4dc738f",
    thumbnail: CleaningServiceLayout,
  },
  {
    id: "8d78c877-d862-4f93-820b-d4fa34ab3288",
    thumbnail: FashionRetailerLayout,
  },
  { id: "6e2b0262-980d-4ada-b5ab-ec77816220e3", thumbnail: SpaLayout },
  { id: "42167141-516c-4051-b7bb-8525cff02f43", thumbnail: SandwichShopLayout },
  { id: "dd774286-372a-4745-8829-d6bcb08370a6", thumbnail: HandymanLayout },
  { id: "127b642e-1e58-4917-a5ac-56769138e13e", thumbnail: BakeryStoreLayout },
  {
    id: "26ae90a0-2d33-4841-876b-b656bbbb707d",
    thumbnail: ParentingBlogLayout,
  },
  { id: "23210ee7-ef96-40f7-9e34-52fd9385e5cd", thumbnail: BeautyShopLayout },
  {
    id: "7d4cf99b-c2bc-4790-996c-ba9f6bfd1bb7",
    thumbnail: CareerServiceLayout,
  },
];

export const TEMPLATE_STYLE_LIST = [
  {
    title: "Playful",
    slug: TEMPLATE_STYLES.PLAYFUL,
    description: "Fun fonts, a bright color scheme, and image-forward design.",
  },
  {
    title: "Modern",
    slug: TEMPLATE_STYLES.MODERN,
    description:
      "Modern fonts, a monochromatic color scheme, and minimalist design.",
  },
  {
    title: "Professional",
    slug: TEMPLATE_STYLES.PROFESSIONAL,
    description:
      "Traditional fonts, a conservative color scheme, and a more formal, structured design.",
  },
  {
    title: "Bold",
    slug: TEMPLATE_STYLES.BOLD,
    description:
      "Bold fonts, strong primary colors, and a direct design style.",
  },
  {
    title: "Classic",
    slug: TEMPLATE_STYLES.CLASSIC,
    description:
      "Serif fonts, neutral colors, and a warm comfortable design style.",
  },
];

export const STEPS = [
  {
    title: "Style",
    subSteps: [
      {
        wizard: {
          title: {
            desktop: "Style it up",
            mobile: "Style it up"
          },
          subtitle: {
            desktop: "Let’s pinpoint your website style so we can use the power of AI to find the best colors, fonts, and structures for your site.",
            mobile: "Let’s pinpoint your website style so we can use the power of AI to find the best colors, fonts, and structures for your site.",
          },
          button: "Header Image",
        },
        key: "style",
        component: Step1,
      },
      {
        wizard: {
          title: {
            desktop: "Let’s get visual",
            mobile: "Let’s get visual",
          },
          subtitle: {
            desktop: "Your hero image is your first impression to each website visitor. Let’s find one that will introduce you to your audience.",
            mobile: "Your hero image is your first impression to each website visitor. Let’s find one that will introduce you to your audience.",
          },
          button: (isGrid) => isGrid === true ? "Layout" : "Colors",
        },
        key: "images",
        component: Step6,
      },
      {
        wizard: {
          title: {
            desktop: "Lay it out",
            mobile: "Lay it out"
          },
          subtitle: {
            desktop: "Now that we have your style dialed in, let's see which header design looks best to you.",
            mobile: "Now that we have your style dialed in, let's see which header design looks best to you.",
          },
          button: "Colors",
        },
        key: "layout",
        component: Layout,
        skipWhen: (isGrid) => isGrid !== true,
      }
    ],
  },
  {
    title: "Color & Font",
    subSteps: [
      {
        wizard: {
          title: {
            desktop: "Show them your true colors",
            mobile: "Show your true colors"
          },
          subtitle: {
            desktop: "These custom color palettes were curated by our designers to best match your {themeType} website style. Missing an important hue? Don’t worry, you’ll be able to fine tune things later.",
            mobile: "These custom palettes, curated by our designers, best match your website style. Missing a hue? You can fine-tune it later.",
          },
          button: "Fonts",
        },
        key: "colors",
        component: Step2,
      },
      {
        wizard: {
          title: {
            desktop: "Let’s find your type",
            mobile: "Let’s find your type",
          },
          subtitle: {
            desktop: "Your font choice reinforces your style and enhances your message. These curated pairings complement your website's {themeType} theme. Select one to get started with - don’t worry, you can always adjust them later!",
            mobile: "Your font choice enhances your style and message. These pairings match your website's  theme. Pick one to start, and always adjust later!",
          },
          //TODO revert to enable layout
          button: "Logo",
        },
        key: "fonts",
        component: Step3,
      },
    ],
  },
  {
    title: "Content",
    subSteps: [
      {
        wizard: {
          title: {
            desktop: "Make it yours with a logo",
            mobile: "Make it yours with a logo",
          },
          subtitle: {
            desktop: "Have a logo? Let’s get it added to the site. If not, we’ll help you build one later.",
            mobile: "Have a logo? Let’s get it added to the site. If not, we’ll help you build one later.",
          },
          button: "Content",
          skipTo: "Content",
        },
        title: "Content",
        key: "logo",
        component: Step5,
      },
      {
        wizard: {
          title: {
            desktop: "Wordsmithing time",
            mobile: "Wordsmithing time"
          },
          subtitle: {
            desktop: "Your tone selection shapes both this section and your entire website. We’ve provided a starting point—now make it yours by updating the copy below!",
            mobile: "Your tone selection shapes both this section and your entire website. We’ve provided a starting point—now make it yours by updating the copy below!",
          },
          button: "Sections",
          buttonGrid: "Pages",
        },
        title: "Content",
        key: "text",
        component: Step7,
      },
      {
        wizard: {
          title: {
            desktop: "Select your Sections",
            mobile: "Select your Sections",
          },
          subtitle: {
            desktop: "Now that we’ve built out your homepage header, let’s add any other sections you’d like to include on your website.",
            mobile: "Now that we’ve built out your homepage header, let’s add any other sections you’d like to include on your website.",
          },
          button: "Apps",
          skipTo: "Review",
          skipStepGroup: "Loader",
          skippable: true
        },
        title: "Content",
        key: "sections",
        isFullScreen: true,
        component: Step9,
        skipWhen: (isGrid) => isGrid === true
      },
      {
        wizard: {
          title: {
            desktop: "Add pages",
            mobile: "Add pages",
          },
          subtitle: {
            desktop: "Every website needs the right pages to tell your story. Choose the ones you want now. It's easy to change, add, or remove them anytime.",
            mobile: "Every website needs the right pages to tell your story. Choose the ones you want now. It's easy to change, add, or remove them anytime.",
          },
          button: "Create my website 🎉",
          buttonReview: "Apps",
          skipTo: "Review",
          skipStepGroup: "Loader",
          skippable: true
        },
        title: "Content",
        key: "sections",
        component: Step8,
        skipWhen: (isGrid) => isGrid !== true,
      },
      {
        wizard: {
          title: {
            desktop: "Apps we recommend for your site",
            mobile: "Apps we recommend for your site"
          },
          subtitle: {
            desktop: "Our AI recommends apps based on your industry. You can explore and add more tools to your site now or later in your sites Settings page.",
            mobile: "Our AI recommends apps based on your industry. You can explore and add more tools to your site now or later in your sites Settings page.",
          },
          button: "Setup",
          skipTo: "Review",
          skipStepGroup: "Loader",
          skippable: true,
        },
        title: "Content",
        key: "recommended-apps",
        isFullScreen: true,
        component: RecommendedApps,
        skipWhen: (isGrid) => isGrid === true,
      },
      {
        wizard: {
          title: {
            desktop: "Set up your Apps",
            mobile: "Set up your Apps"
          },
          subtitle: {
            desktop: "Provide your business details below.  We only use this address to calculate shipping and taxes.",
            mobile: "Provide your business details below.  We only use this address to calculate shipping and taxes.",
          },
          button: "Create my website 🎉",
          skipTo: "Create my website 🎉",
          skipStepGroup: "Loader",
          skippable: true,
        },
        title: "Content",
        key: "apps-setup",
        isFullScreen: true,
        component: AppsSetup,
      }
    ],
  },
  {
    title: "Loader",
    key: "loader",
    skipStepper: true,
    component: null,
  },
  {
    wizard: {
      title: "Review",
      subtitle: "",
      button: "",
    },
    title: "Review",
    key: "review",
    component: StepPublished,
  },
];

export const FONTS = {
  [TEMPLATE_STYLES.PLAYFUL]: {
    v1: [
      { header: "Orelega One, serif", body: "Arimo, sans-serif" },
      { header: "Chango, sans-serif", body: "Gluten, script" },
      { header: "Yeseva One, serif", body: "Inter, sans-serif" },
      { header: "Young Serif, serif", body: "Averia Serif Libre, serif" },
      { header: "Tilt Warp, sans-serif", body: "Be Vietnam Pro, sans-serif" },
      { header: "Titan One, sans-serif", body: "Blinker, sans-serif" },
      { header: "Shrikhand, script", body: "Bree Serif, serif" },
      { header: "Namdhinggo, serif", body: "Cagliostro, sans-serif" },
      { header: "Reenie Beanie, script", body: "Cutive Mono, serif" },
      { header: "Redressed, script", body: "Diphylleia, serif" },
      { header: "Protest Strike, sans-serif", body: "DM Sans, sans-serif" },
      { header: "Pirata One, script", body: "Esteban, serif" },
      { header: "Over the Rainbow, script", body: "Lora, serif" },
      { header: "Oi, serif", body: "Lexend Deca, sans-serif" },
      { header: "Monoton, sans-serif", body: "Fredoka, sans-serif" },
      { header: "Lemon, serif", body: "Radio Canada Big, sans-serif" },
      { header: "Itim, script", body: "Averia Sans Libre, sans-serif" },
      { header: "Gochi Hand, script", body: "Prompt, sans-serif" },
    ],
    v2: [
      { header: "Corben, serif", body: "Montserrat, sans-serif" },
      { header: "Orelega One, serif", body: "Arimo, sans-serif" },
      { header: "Chango, sans-serif", body: "Gluten, script" },
      { header: "Yeseva One, serif", body: "Inter, sans-serif" },
      { header: "Young Serif, serif", body: "Averia Serif Libre, serif" },
      { header: "Tilt Warp, sans-serif", body: "Be Vietnam Pro, sans-serif" },
      { header: "Titan One, sans-serif", body: "Blinker, sans-serif" },
      { header: "Shrikhand, script", body: "Bree Serif, serif" },
      { header: "Namdhinggo, serif", body: "Cagliostro, sans-serif" },
      { header: "Reenie Beanie, script", body: "Cutive Mono, serif" },
      // { header: "Redressed, script", body: "Diphylleia, serif" },
      { header: "Protest Strike, sans-serif", body: "DM Sans, sans-serif" },
      { header: "Pirata One, script", body: "Esteban, serif" },
      { header: "Over the Rainbow, script", body: "Lora, serif" },
      { header: "Oi, serif", body: "Lexend Deca, sans-serif" },
      { header: "Monoton, sans-serif", body: "Fredoka, sans-serif" },
      { header: "Lemon, serif", body: "Radio Canada Big, sans-serif" },
      { header: "Itim, script", body: "Averia Sans Libre, sans-serif" },
      { header: "Gochi Hand, script", body: "Prompt, sans-serif" },
  ]},
  [TEMPLATE_STYLES.MODERN]: {
    v1: [
        { header: "Arimo, sans-serif", body: "Arimo, sans-serif" },
        { header: "Montserrat, sans-serif", body: "Montserrat, sans-serif" },
        { header: "Aboreto, serif", body: "Open Sans, sans-serif" },
        { header: "Albert Sans, sans-serif", body: "Albert Sans, sans-serif" },
        { header: "Barlow Condensed, sans-serif", body: "Barlow, sans-serif" },
        { header: "Exo 2, sans-serif", body: "Exo 2, sans-serif" },
        { header: "Expletus Sans, sans-serif", body: "Lato, sans-serif" },
        { header: "Genos, sans-serif", body: "Nunito Sans, sans-serif" },
        { header: "Geologica, sans-serif", body: "Geologica, sans-serif" },
        { header: "Georama, sans-serif", body: "Georama, sans-serif" },
        { header: "GFS Neohellenic, sans-serif", body: "Hind, sans-serif" },
        { header: "Gruppo, sans-serif", body: "IBM Plex Sans, sans-serif" },
        { header: "Heebo, sans-serif", body: "Heebo, sans-serif" },
        { header: "Julius Sans One, sans-serif", body: "Sarala, sans-serif" },
        { header: "League Gothic, sans-serif", body: "Fira Sans, sans-serif" },
        { header: "Monoton, sans-serif", body: "Montserrat, sans-serif" },
        { header: "Quicksand, sans-serif", body: "Quicksand, sans-serif" },
        { header: "Tenor Sans, sans-serif", body: "Tenor Sans, sans-serif" },
    ],
    v2: [
      { header: "Inter, sans-serif", body: "Inter, sans-serif" },
      { header: "Arimo, sans-serif", body: "Arimo, sans-serif" },
      { header: "Montserrat, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Aboreto, serif", body: "Open Sans, sans-serif" },
      { header: "Albert Sans, sans-serif", body: "Albert Sans, sans-serif" },
      { header: "Barlow Condensed, sans-serif", body: "Barlow, sans-serif" },
      { header: "Exo 2, sans-serif", body: "Exo 2, sans-serif" },
      { header: "Expletus Sans, sans-serif", body: "Lato, sans-serif" },
      { header: "Genos, sans-serif", body: "Nunito Sans, sans-serif" },
      { header: "Geologica, sans-serif", body: "Geologica, sans-serif" },
      { header: "Georama, sans-serif", body: "Georama, sans-serif" },
      { header: "GFS Neohellenic, sans-serif", body: "Hind, sans-serif" },
      { header: "Gruppo, sans-serif", body: "IBM Plex Sans, sans-serif" },
      { header: "Heebo, sans-serif", body: "Heebo, sans-serif" },
      { header: "Julius Sans One, sans-serif", body: "Sarala, sans-serif" },
      { header: "League Gothic, sans-serif", body: "Fira Sans, sans-serif" },
      { header: "Monoton, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Quicksand, sans-serif", body: "Quicksand, sans-serif" },
  ]},
  [TEMPLATE_STYLES.CLASSIC]: {
    v1: [
      { header: "Taviraj, serif", body: "Work Sans, sans-serif" },
      { header: "Alice, serif", body: "Rufina, serif" },
      { header: "Asul, serif", body: "Quattrocento Sans, sans-serif" },
      { header: "Cagliostro, sans-serif", body: "Red Hat Text, sans-serif" },
      { header: "Calistoga, serif", body: "Libre Caslon Text, serif" },
      { header: "DM Serif Display, serif", body: "Scheherazade New, serif" },
      { header: "Goudy Bookletter 1911, serif", body: "Buenard, serif" },
      { header: "IM Fell DW Pica SC, serif", body: "Averia Libre, script" },
      { header: "Libre Baskerville, serif", body: "Libre Baskerville, serif" },
      { header: "Macondo Swash Caps, script", body: "Fraunces, serif" },
      { header: "Lateef, serif", body: "Crimson Pro, serif" },
      { header: "Playfair Display, serif", body: "Playfair Display, serif" },
      { header: "Shrikhand, script", body: "Proza Libre, sans-serif" },
      { header: "Vollkorn SC, serif", body: "Spectral, serif" },
      { header: "Yanone Kaffeesatz, sans-serif", body: "Syne, sans-serif" },
      { header: "Young Serif, serif", body: "Wittgenstein, serif" },
      { header: "Yeseva One, serif", body: "Merriweather, serif" },
    ],
    v2: [
        { header: "DM Serif Text, serif", body: "Hanken Grotesk, sans-serif" },
        { header: "Taviraj, serif", body: "Work Sans, sans-serif" },
        { header: "Alice, serif", body: "Rufina, serif" },
        { header: "Asul, serif", body: "Quattrocento Sans, sans-serif" },
        { header: "Cagliostro, sans-serif", body: "Red Hat Text, sans-serif" },
        { header: "Calistoga, serif", body: "Libre Caslon Text, serif" },
        { header: "DM Serif Display, serif", body: "Scheherazade New, serif" },
        { header: "Goudy Bookletter 1911, serif", body: "Buenard, serif" },
        { header: "IM Fell DW Pica SC, serif", body: "Averia Libre, script" },
        { header: "Libre Baskerville, serif", body: "Libre Baskerville, serif" },
        { header: "Macondo Swash Caps, script", body: "Fraunces, serif" },
        { header: "Lateef, serif", body: "Crimson Pro, serif" },
        { header: "Playfair Display, serif", body: "Playfair Display, serif" },
        { header: "Shrikhand, script", body: "Proza Libre, sans-serif" },
        { header: "Vollkorn SC, serif", body: "Spectral, serif" },
        { header: "Yanone Kaffeesatz, sans-serif", body: "Syne, sans-serif" },
        { header: "Young Serif, serif", body: "Wittgenstein, serif" },
        { header: "Yeseva One, serif", body: "Merriweather, serif" },
  ]},
  [TEMPLATE_STYLES.PROFESSIONAL]: {
    v1: [
        { header: "Playfair Display, serif", body: "Arimo, sans-serif" },
        { header: "Yeseva One, serif", body: "Inter, sans-serif" },
        { header: "Vollkorn SC, serif", body: "Vollkorn, serif" },
        { header: "Calistoga, serif", body: "Montserrat, sans-serif" },
        { header: "Open Sans, sans-serif", body: "Open Sans, sans-serif" },
        { header: "Murecho, sans-serif", body: "Work Sans, sans-serif" },
        { header: "Outfit, sans-serif", body: "Outfit, sans-serif" },
        { header: "Ovo, serif", body: "Ovo, serif" },
        { header: "Parisienne, script", body: "Petrona, serif" },
        { header: "Beiruti, sans-serif", body: "Beiruti, sans-serif" },
        { header: "Caprasimo, serif", body: "Sansita, sans-serif" },
        { header: "Sofia Sans Condensed, sans-serif", body: "Sofia Sans, sans-serif" },
        { header: "Suravaram, serif", body: "Suravaram, serif" },
        { header: "Urbanist, sans-serif", body: "Urbanist, sans-serif" },
        { header: "Zen Antique Soft, serif", body: "Zen Maru Gothic, serif" },
        { header: "Zen Maru Gothic, serif", body: "Zen Maru Gothic, serif" },
        { header: "Metal, serif", body: "Tenor Sans, sans-serif" },
        { header: "Tenor Sans, sans-serif", body: "Lora, serif" },
    ],
    v2: [
      { header: "Montserrat, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Playfair Display, serif", body: "Arimo, sans-serif" },
      { header: "Yeseva One, serif", body: "Inter, sans-serif" },
      { header: "Vollkorn SC, serif", body: "Vollkorn, serif" },
      { header: "Calistoga, serif", body: "Montserrat, sans-serif" },
      { header: "Open Sans, sans-serif", body: "Open Sans, sans-serif" },
      { header: "Murecho, sans-serif", body: "Work Sans, sans-serif" },
      { header: "Outfit, sans-serif", body: "Outfit, sans-serif" },
      { header: "Ovo, serif", body: "Ovo, serif" },
      { header: "Parisienne, script", body: "Petrona, serif" },
      { header: "Beiruti, sans-serif", body: "Beiruti, sans-serif" },
      { header: "Caprasimo, serif", body: "Sansita, sans-serif" },
      { header: "Sofia Sans Condensed, sans-serif", body: "Sofia Sans, sans-serif" },
      { header: "Suravaram, serif", body: "Suravaram, serif" },
      { header: "Urbanist, sans-serif", body: "Urbanist, sans-serif" },
      { header: "Zen Antique Soft, serif", body: "Zen Maru Gothic, serif" },
      { header: "Zen Maru Gothic, serif", body: "Zen Maru Gothic, serif" },
      { header: "Metal, serif", body: "Tenor Sans, sans-serif" },
  ]},
  [TEMPLATE_STYLES.BOLD]: {
    v1: [
      { header: "Anton, serif", body: "Open Sans, sans-serif" },
      { header: "League Gothic, sans-serif", body: "DM Mono, serif" },
      { header: "Alfa Slab One, sans-serif", body: "Almarai, sans-serif" },
      { header: "Bungee, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Oi, serif", body: "Inter, sans-serif" },
      { header: "Titan One, sans-serif", body: "Arimo, sans-serif" },
      { header: "Russo One, sans-serif", body: "Biryani, sans-serif" },
      { header: "Rammetto One, sans-serif", body: "Cabin, sans-serif" },
      { header: "Protest Strike, sans-serif", body: "Encode Sans, sans-serif" },
      { header: "Monoton, sans-serif", body: "Hanken Grotesk, sans-serif" },
      { header: "Montserrat, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Major Mono Display, sans-serif", body: "Fira Mono, sans-serif" },
      { header: "Gravitas One, serif", body: "Buenard, serif" },
      { header: "Diplomata, serif", body: "Corben, serif" },
      { header: "Caprasimo, serif", body: "Libre Caslon Text, serif" },
      { header: "Candal, sans-serif", body: "Mada, sans-serif" },
      { header: "Bebas Neue, sans-serif", body: "Fredoka, sans-serif" },
    ],
    v2: [
      { header: "Inter, sans-serif", body: "Inter, sans-serif" },
      { header: "Anton, serif", body: "Open Sans, sans-serif" },
      { header: "League Gothic, sans-serif", body: "DM Mono, serif" },
      { header: "Alfa Slab One, sans-serif", body: "Almarai, sans-serif" },
      { header: "Bungee, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Oi, serif", body: "Inter, sans-serif" },
      { header: "Titan One, sans-serif", body: "Arimo, sans-serif" },
      { header: "Russo One, sans-serif", body: "Biryani, sans-serif" },
      { header: "Rammetto One, sans-serif", body: "Cabin, sans-serif" },
      { header: "Protest Strike, sans-serif", body: "Encode Sans, sans-serif" },
      { header: "Monoton, sans-serif", body: "Hanken Grotesk, sans-serif" },
      { header: "Montserrat, sans-serif", body: "Montserrat, sans-serif" },
      { header: "Major Mono Display, sans-serif", body: "Fira Mono, sans-serif" },
      { header: "Gravitas One, serif", body: "Buenard, serif" },
      { header: "Diplomata, serif", body: "Corben, serif" },
      { header: "Caprasimo, serif", body: "Libre Caslon Text, serif" },
      { header: "Candal, sans-serif", body: "Mada, sans-serif" },
      { header: "Bebas Neue, sans-serif", body: "Fredoka, sans-serif" },
  ]},
};

/*
  Mappings with figma,
  {
    primary: primary,
    secondary: secondary,
    textPrimary: tertiary,
    textSecondary: accent,
    complementary: complementary,
  }
*/

export const SWATCHES = {
  [TEMPLATE_STYLES.PLAYFUL]: {
    v1: {
      default: {
        primary: "#F45D48",
        secondary: "#0A8080",
        textPrimary: "#545B5B",
        textSecondary: "#FFFFFF",
        complementary: "#F6F4F1",
      },
      swatches: [
        {
          primary: "#397DA7",
          secondary: "#024B73",
          textPrimary: "#031424",
          textSecondary: "#FFFFFF",
          complementary: "#F6F4F1",
        },
        {
          primary: "#05A569",
          secondary: "#06161B",
          textPrimary: "#06161B",
          textSecondary: "#FFFFFF",
          complementary: "#10495C",
        },
        {
          primary: "#5046E5",
          secondary: "#1C2430",
          textPrimary: "#101827",
          textSecondary: "#FFFFFF",
          complementary: "#7BCFF7",
        },
      ],
    },
    v2: {
    default: {
      primary: '#F45D48',
      secondary: '#F9E5D0',
      textPrimary: '#144936',
      textSecondary: '#FFFFFF',
      complementary: '#FFF4E9',
    },
    swatches: [
      {
        primary: "#397DA7",
        secondary: "#024B73",
        textPrimary: "#031424",
        textSecondary: "#FFFFFF",
        complementary: "#F6F4F1",
      },
      {
        primary: "#05A569",
        secondary: "#06161B",
        textPrimary: "#06161B",
        textSecondary: "#FFFFFF",
        complementary: "#10495C",
      },
      {
        primary: "#5046E5",
        secondary: "#1C2430",
        textPrimary: "#101827",
        textSecondary: "#FFFFFF",
        complementary: "#7BCFF7",
      },
    ],
  }},
  [TEMPLATE_STYLES.MODERN]: {
    v1: {
      default: {
        primary: "#000000",
        secondary: "#000000",
        textPrimary: "#000000",
        textSecondary: "#FFFFFF",
        complementary: "#DFDFDF",
      },
      swatches: [
        {
          primary: "#3557FF",
          secondary: "#1F212D",
          textPrimary: "#090B1B",
          textSecondary: "#FFFFFF",
          complementary: "#D0DBE7",
        },
        {
          primary: "#FF3366",
          secondary: "#FF3366",
          textPrimary: "#222222",
          textSecondary: "#FFFFFF",
          complementary: "#F8F8F9",
        },
        {
          primary: "#122E34",
          secondary: "#929B9C",
          textPrimary: "#181818",
          textSecondary: "#FFFFFF",
          complementary: "#DADEDF",
        },
      ],
    },
    v2: {
    default: {
      primary: '#FFFFFF',
      secondary: '#222325',
      textPrimary: '#FFFFFF',
      textSecondary: '#FFFFFF',
      complementary: '#222325',
    },
    swatches: [
      {
        primary: "#213B2A",
        secondary: "#FFFFFF",
        textPrimary: "#213B2A",
        complementary: "#EDEFF2",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#476B60",
        secondary: "#EAE6E0",
        textPrimary: "#543D28",
        complementary: "#7F5F51",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#3E435C",
        secondary: "#EEF1F9",
        textPrimary: "#3E435C",
        complementary: "#8592E0",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#393730",
        secondary: "#EAE6DB",
        textPrimary: "#393730",
        complementary: "#B7B2A3",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#00C7BD",
        secondary: "#243E40",
        textPrimary: "#FFFFFF",
        complementary: "#1B3436",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#BC5E39",
        secondary: "#F9F6EE",
        textPrimary: "#BC5E39",
        complementary: "#E6DAC3",
        textSecondary: "#F9F6EE"
      },
      {
        primary: "#717D97",
        secondary: "#EEE8DA",
        textPrimary: "#010002",
        complementary: "#EEE8DA",
        textSecondary: "#FFFFFF"
      },
      {
        primary: "#211F21",
        secondary: "#F6F0CD",
        textPrimary: "#211F21",
        complementary: "#EEE8C5",
        textSecondary: "#F6F0CD"
      },
      {
        primary: "#FFCB6B",
        secondary: "#603B33",
        textPrimary: "#FFFFFF",
        complementary: "#6D483D",
        textSecondary: "#603B33"
      },
      {
        primary: "#C7C7C7",
        secondary: "#FFFFFF",
        textPrimary: "#010101",
        complementary: "#888888",
        textSecondary: "#010101"
      },
      {
        primary: "#FF8661",
        secondary: "#2F2420",
        textPrimary: "#E9D3B3",
        complementary: "#4E3A33",
        textSecondary: "#153538"
      }
    ],
  }},
  [TEMPLATE_STYLES.CLASSIC]: {
    v1: {
      default: {
        primary: "#6A7A7A",
        secondary: "#C9B391",
        textPrimary: "#282828",
        textSecondary: "#FFFFFF",
        complementary: "#EBEBEB",
      },
      noGrid: {
        primary: "#6A7A7A",
        secondary: "#C9B391",
        textPrimary: "#282828",
        textSecondary: "#FFFFFF",
        complementary: "#EBEBEB",
      },
      swatches: [
        {
          primary: "#8F8A81",
          secondary: "#C1BAB3",
          textPrimary: "#2B2824",
          textSecondary: "#FFFFFF",
          complementary: "#605D5A",
        },
        {
          primary: "#848C83",
          secondary: "#ABBFA3",
          textPrimary: "#191514",
          textSecondary: "#FFFFFF",
          complementary: "#4A5049",
        },
        {
          primary: "#336266",
          secondary: "#E7BD86",
          textPrimary: "#174B50",
          textSecondary: "#FFFFFF",
          complementary: "#EBEBEB",
        },
      ],
    },
    v2: {
    default: {
      primary: '#b7b2a3',
      secondary: '#ffffff',
      textPrimary: '#393730',
      textSecondary: '#393730',
      complementary: '#eae6db',
    },
    swatches: [
      {
        primary: "#8F8A81",
        secondary: "#C1BAB3",
        textPrimary: "#2B2824",
        textSecondary: "#FFFFFF",
        complementary: "#605D5A",
      },
      {
        primary: "#848C83",
        secondary: "#ABBFA3",
        textPrimary: "#191514",
        textSecondary: "#FFFFFF",
        complementary: "#4A5049",
      },
      {
        primary: "#336266",
        secondary: "#E7BD86",
        textPrimary: "#174B50",
        textSecondary: "#FFFFFF",
        complementary: "#EBEBEB",
      },
    ],
  }},
  [TEMPLATE_STYLES.PROFESSIONAL]: {
    v1: {
      default: {
        primary: "#0B4B4B",
        secondary: "#C7D0D0",
        textPrimary: "#0C2424",
        textSecondary: "#FFFFFF",
        complementary: "#F2F0EA",
      },
      swatches: [
        {
          primary: "#2A6A49",
          secondary: "#E4E0A1",
          textPrimary: "#1E3F36",
          textSecondary: "#FFFFFF",
          complementary: "#EDEBE9",
        },
        {
          primary: "#768E95",
          secondary: "#E8F1F4",
          textPrimary: "#203A4C",
          textSecondary: "#FFFFFF",
          complementary: "#E3E1DB",
        },
        {
          primary: "#919088",
          secondary: "#C6C5BF",
          textPrimary: "#302B2B",
          textSecondary: "#FFFFFF",
          complementary: "#E3E1DB",
        },
      ],
    },
    v2:{
    default: {
      primary: '#F6F8F8',
      secondary: '#20242B',
      textPrimary: '#FFFFFF',
      textSecondary: '#20242B',
      complementary: '#20242B',
    },
    swatches: [
      {
        primary: "#2A6A49",
        secondary: "#E4E0A1",
        textPrimary: "#1E3F36",
        textSecondary: "#FFFFFF",
        complementary: "#EDEBE9",
      },
      {
        primary: "#768E95",
        secondary: "#E8F1F4",
        textPrimary: "#203A4C",
        textSecondary: "#FFFFFF",
        complementary: "#E3E1DB",
      },
      {
        primary: "#919088",
        secondary: "#C6C5BF",
        textPrimary: "#302B2B",
        textSecondary: "#FFFFFF",
        complementary: "#E3E1DB",
      },
    ],
  }},
  [TEMPLATE_STYLES.BOLD]: {
    v1:{
      default: {
        primary: "#0048FF",
        secondary: "#368E78",
        textPrimary: "#051D59",
        textSecondary: "#FFFFFF",
        complementary: "#FFFFFF",
      },
      swatches: [
        {
          primary: "#FFFFFF",
          secondary: "#080808",
          textPrimary: "#080808",
          textSecondary: "#56BBB5",
          complementary: "#E0FE6A",
        },
        {
          primary: "#03BF8F",
          secondary: "#06261A",
          textPrimary: "#06261A",
          textSecondary: "#FFFFFF",
          complementary: "#6BFEBE",
        },
        {
          primary: "#DE1630",
          secondary: "#DE1630",
          textPrimary: "#080808",
          textSecondary: "#FFFFFF",
          complementary: "#FFFFFF",
        },
      ],
    },
    v2: {
    default: {
      primary: '#222325',
      secondary: '#222325',
      textPrimary: '#FFFFFF',
      textSecondary: '#FFFFFF',
      complementary: '#0A3CF5',
    },
    swatches: [
      {
        primary: "#FFFFFF",
        secondary: "#080808",
        textPrimary: "#080808",
        textSecondary: "#56BBB5",
        complementary: "#E0FE6A",
      },
      {
        primary: "#03BF8F",
        secondary: "#06261A",
        textPrimary: "#06261A",
        textSecondary: "#FFFFFF",
        complementary: "#6BFEBE",
      },
      {
        primary: "#DE1630",
        secondary: "#DE1630",
        textPrimary: "#080808",
        textSecondary: "#FFFFFF",
        complementary: "#FFFFFF",
      },
    ],
  }},
};

export const EXCLUDED_SWATCHES = {
  10002: true,
  10003: true,
  10007: true,
  10016: true,
  10011: true,
  10004: true,
  10008: true,
  10009: true,
  10012: true,
  10017: true,
};

export const ALL_STEPS = STEPS.flatMap(step => {
  if(step.subSteps?.length > 0) return step.subSteps
  return step
})

export const STEPS_ENUM = Object.freeze({
  GetStarted: 0,
  Style: 1,
  HeroBackground: 2,
  Colors: 3,
  Fonts: 4,
  HeaderLogo: 5,
  HeroText: 6,
  Sections: 7,
});

export const ONBOARDING_STATUS = Object.freeze({
  Unknown: 0,
  Complete: 1,
  InProgress: 2
})

export const TONES = [
  {
    tone: 'Neutral',
    label: 'neutral',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Objective and unbiased, presenting information without strong opinions'
  },
  {
    tone: 'Friendly',
    label: 'friendly',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Casual, warm, approachable, but still respectful'
  },
  {
    tone: 'Informative',
    label: 'informative',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Focused on delivering clear, accurate, and helpful details'
  },
  {
    tone: 'Thoughtful',
    label: 'thoughtful',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Considerate and reflective, showing care and attention to the reader'
  },
  {
    tone: 'Persuasive',
    label: 'persuasive',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Aimed at influencing the reader through compelling arguments'
  },
  {
    tone: 'Formal',
    label: 'formal',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Polite and respectful, following traditional language conventions and structure'
  },
  {
    tone: 'Professional',
    label : 'professional',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Clear, direct, and courteous, suited for business or formal setting'
  },
  {
    tone: 'Custom',
    label: 'custom',
    headline: '',
    subtitle: '',
    buttonText: '',
    description: 'Customize your tone to match your brand'
  }
]
export const RECOMMENDED_APPS = Object.freeze([
  {
    id: "store",
    name: "Online Store",
    description: "Turn your website into an online shop where customers can browse, buy, and pay effortlessly.",
    enabled: false,
    icon: "store_tag.svg",
    background: "#014019",
    skippable: false,
    "badge": "Best Match",
    disabled: false
  },
  {
    id: "appointments",
    name: "Appointment Scheduler",
    description: "Let visitors book appointments for services directly on your website for easy scheduling.",
    enabled: false,
    icon: "appointments.svg",
    background: "#00245B",
    skippable: false,
  },
  {
    id: "blog",
    name: "Blog",
    description: "Share your expertise and updates by posting engaging blog articles on your website.",
    enabled: false,
    icon: "blog.svg",
    background: "#031E3D",
    skippable: true,
  }
])

export const STORE_ENABLED_PLANS = ["ECOMESSENTIALS", "ECOMPREMIUM"]
export const APPOINTMENT_ENABLED_PLANS = ["ECOMBOOKINGS", "ECOMESSENTIALS", "ECOMPREMIUM"]

// Single source of truth for plan-gated apps/sections. Ids match `RECOMMENDED_APPS`
// and the Pages step section ids so the same helper can gate both at the write site.
const APP_PLAN_GATES = {
  store: STORE_ENABLED_PLANS,
  appointments: APPOINTMENT_ENABLED_PLANS,
}

export const isAppEnabledForPlan = (appId, planSku) => {
  const allowedPlans = APP_PLAN_GATES[appId]
  if (!allowedPlans) return true
  return allowedPlans.includes(planSku)
}

export const CLASSIC_LAYOUT_MENU = [
  { key: 'header_and_introduction', value: 'Home', enabled: true, active: true },
  { key: 'contact_form', value: 'Contact', enabled: false },
  { key: 'footer', value: 'Footer', enabled: true },
  { key: 'products', value: 'Products', enabled: false },
  { key: 'services', value: 'Services', enabled: false },
  { key: 'testimonials', value: 'Reviews', enabled: false },
  { key: 'about', value: 'About', enabled: false },
  { key: 'portfolio', value: 'Portfolio', enabled: false },
  { key: 'team', value: 'Team', enabled: false },
  { key: 'faq', value: 'FAQs', enabled: false }
]
export const OLD_GRID_LAYOUT_MENU = [
  { key: 'header_and_introduction', value: 'Home', enabled: true, active: true },
  { key: 'contact_form', value: 'Contact', enabled: true },
  { key: 'footer', value: 'Footer', enabled: true },
  { key: 'products', value: 'Products', enabled: false },
  { key: 'services', value: 'Services', enabled: false },
  { key: 'testimonials', value: 'Testimonials', enabled: true },
  { key: 'about', value: 'About', enabled: true },
]